module.exports = __webpack_public_path__ + "media/images/wedding/top/hall-list/plan-wedding-lineup-tokai-1-7bfa1475702f732545a0e393bea09874.png";